import { GuestVenue, Maybe } from 'lib/gql'

export interface BrandingColors {
  primaryBrandingColor: string
  primaryBrandingText: string
  activeIndicatorColor: string
  accentBrandingColor: string
  accentBrandingText: string
  accentBrandingFallback: string
  toastInfoBackground: string
  toastInfoText: string
  toastPositiveBackground: string
  tickFillSelected: string
  tickFillSelectedHover: string
  tickFillSelectedHoverActive: string
  tickMarkFill: string
  tabBannerBackground: string
}

const primitives = {
  nero: '#181819',
  white: '#FFFFFF',
  burple: '#6F3DFF',
}

export const useVenueBrandingColors = (
  venue?: Maybe<
    Pick<
      GuestVenue,
      | 'brandingEnabled'
      | 'brandingPrimary'
      | 'brandingPrimaryText'
      | 'brandingAccent'
      | 'brandingAccentText'
      | 'brandingAccent'
      | 'brandingAccent'
      | 'brandingAccent'
      | 'brandingAccentText'
      | 'brandingPrimary'
    >
  >,
): {
  colors: BrandingColors
  hasCustomBranding: boolean
} => {
  let colors: BrandingColors = {
    primaryBrandingColor: primitives.nero,
    primaryBrandingText: primitives.white,
    activeIndicatorColor: primitives.burple,
    accentBrandingColor: primitives.burple,
    accentBrandingText: primitives.white,
    accentBrandingFallback: primitives.burple,

    // Toast styles
    toastInfoBackground: primitives.burple,
    toastInfoText: primitives.white,
    toastPositiveBackground: primitives.burple,

    // Radio and checkbox styles
    tickFillSelected: primitives.burple,
    tickFillSelectedHover: primitives.burple,
    tickFillSelectedHoverActive: primitives.burple,
    tickMarkFill: primitives.white,

    // Start a tab banner
    tabBannerBackground: primitives.burple,
  }

  const isCustomBrandingEnabled = !!venue?.brandingEnabled

  if (isCustomBrandingEnabled) {
    colors = {
      primaryBrandingColor: venue?.brandingPrimary || primitives.nero,
      primaryBrandingText: venue?.brandingPrimaryText || primitives.white,
      activeIndicatorColor: 'currentColor',
      accentBrandingColor: venue?.brandingAccent || primitives.burple,
      accentBrandingText: venue?.brandingAccentText || primitives.white,
      accentBrandingFallback: primitives.nero,

      // Toast styles
      toastInfoBackground: primitives.nero,
      toastInfoText: primitives.white,
      toastPositiveBackground: primitives.nero,

      // Radio and checkbox styles
      tickFillSelected: venue?.brandingAccent || primitives.burple,
      tickFillSelectedHover: venue?.brandingAccent || primitives.burple,
      tickFillSelectedHoverActive: venue?.brandingAccent || primitives.burple,
      tickMarkFill: venue?.brandingAccentText || primitives.white,

      // Start a tab banner
      tabBannerBackground: venue?.brandingPrimary || primitives.burple,
    }
  }

  return { colors, hasCustomBranding: isCustomBrandingEnabled }
}
